import { GeneralQuestionUIConfig, GeneralQuestionUIConfigOption } from "../../../../../cvp-webgames-core/Components/ui/react/core-general-question-ui";
import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { ScoringType } from "../../../../../misc/tools";
import { GameBaseScenario } from "../../../../GameBaseScenario";
import Scenario2NonAffiliatedStudents, { scenario2NonAffiliatedStudentsAudioCaching, scenario2NonAffiliatedStudentsVideoSegments } from "../../../scenario2-non-affiliated-students";
import { NonAffiliatedStudentsComponentsStep0ComponentMainConfig, NonAffiliatedStudentsComponentsStep0ComponentPart1Config } from "../non-affiliated-students-components-step0";

export default class NonAffiliatedStudentsComponentsStep0Part1 extends BaseScenarioPart<GameBaseScenario> {
	private get config(): NonAffiliatedStudentsComponentsStep0ComponentPart1Config {
		return this.mainConfig.part1Config;
	}
	constructor(scenario: GameBaseScenario, private onDone: () => void, private id: string, private mainConfig: NonAffiliatedStudentsComponentsStep0ComponentMainConfig) {
		super(scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	private stepName = 'Step 1';

	public start() {
		this.section1();
	}

	public section1() {
		const context = this;
		let chapter = context.config.chapter;
		context.playVideoChapter(chapter(), () => {
			context.section2();
		})
	}

	public section2() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType1UI({
			title: this.mainConfig.scenario.props.name,
			subtitle: (this.stepName + ' - Question 1'),
			audioUrl: scenario2NonAffiliatedStudentsAudioCaching.getItemByKey(scenario2NonAffiliatedStudentsAudioCaching.audioKeys.question1).src,
			questionTitle: 'Select the one that best describes the employee\'s action',
			options: [
				{
					title: 'Human Error',
					description: `
						<ul>
						<li>The employee is not accountable.</li>
						<li>The employee should be consoled.</li>
						<li>The employee should be interviewed and consulted during any systems level analysis.</li>
						</ul>
					`,
					feedbackHtml: `
						<p class="default-text">This is not the best option. Chris did not commit an error while 
						working appropriately and in the patient’s best interest.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				},
				{
					title: 'At Risk Behavior',
					description: `
						<ul>
						<li>The employee is accountable and should receive coaching.</li>
						<li>The employee may participate in teaching others the lessons learned.</li>
						</ul>
					`,
					feedbackHtml: `
						<p class="default-text">This is not the best option. Chris knowingly violated a policy 
						and made a potentially unsafe choice, however the level of risk created warrants 
						a different response.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				},
				{
					title: 'Reckless Behavior',
					description: `
						<ul>
						<li>Discipline may be warranted.</li>
						<li>The employee is accountable and should receive re-training/coaching as necessary.</li>
						<li>The employee may participate in teaching others the lessons learned.</li>
						</ul>
					`,
					feedbackHtml: `
						<p class="default-text">Correct. Chris’s behavior was reckless. He knowingly 
						violated policy and his decision to take unauthorized students into critical patient 
						care areas creates a level of risk that is not justifiable under any circumstance. 
						This is a dangerous and unsafe choice made with little or no concern about the 
						risks associated with it.</p>
					`,
					isCorrect: true,
					score: ScoringType.good
				}
			],
			
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario2NonAffiliatedStudentsVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType1(selectedChoices[0], (this.stepName + ' - Question 1 '), parentQuestionConfig, () => {
					this.section3();
				}, () => {
					this.section3();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[0], mentorInfo.chapterIds[1], mentorInfo.chapterIds[2], 'Human Error');
			}
		}, 0);
	}

	public section3() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType1UI({
			title: this.mainConfig.scenario.props.name,
			audioUrl: scenario2NonAffiliatedStudentsAudioCaching.getItemByKey(scenario2NonAffiliatedStudentsAudioCaching.audioKeys.question2).src,
			subtitle: (this.stepName + ' - Question 2'),
			questionTitle: 'Based on the correct answer, what is the appropriate path to take with the employee',
			options: [
				{
					title: 'Console',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">In Just Culture, employees are to be consoled if their behavior was considered a human error.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				},
				{
					title: 'Console and coach',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">This is not the best option. Coaching is needed for employee’s actions that are considered “at-risk behavior.”</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				},
				{
					title: 'Console, coach, and consider discipline',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">Correct. Consider disciplinary action as the employee actions are considered reckless and a repeated behavior.</p>
					`,
					isCorrect: true,
					score: ScoringType.good
				}
			],
			
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario2NonAffiliatedStudentsVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType1(selectedChoices[0], (this.stepName + ' - Question 2 '), parentQuestionConfig, () => {
					this.onDone();
				}, () => {
					this.onDone();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[3], mentorInfo.chapterIds[4], mentorInfo.chapterIds[5], 'Console');
			}
		}, 1);
	}
}